module.exports = __webpack_public_path__ + "__static/site-1749741178941/img/how-works-desktop--en.71da8971.jpg";